/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-week-end-10': {
    width: 48,
    height: 46,
    viewBox: '0 0 48 46',
    data: '<path pid="0" class="st0" d="M45.9 11.1L31.2 8.5l-.9-7.1c-.1-.4-.3-.8-.6-1S29 0 28.6 0L1.4 3.4c-.9.1-1.5.8-1.4 1.7l3.9 31.8c.1.4.3.8.6 1 .3.2.6.3 1 .3h.2l6.1-.8-.3 1.6c-.1.8.4 1.7 1.3 1.8l27 4.8h.3c.3 0 .6-.1.9-.3.3-.2.6-.6.6-1l5.6-31.6c.1-.7-.5-1.5-1.3-1.6M27.4 3.3l.6 4.6-9.1-1.6c-.4-.1-.8 0-1.2.3-.3.2-.6.6-.6 1L14 24.9l-8.3 1L3.3 6.3l24.1-3zM6.8 35l-.7-6 7.4-.9-1.1 6.2-5.6.7zm9.1-2.8l23.9 4.2-1 5.9-23.9-4.2 1-5.9zm27.9-18.3l-3.4 19.5-23.9-4.2 3.4-19.5 23.9 4.2z"/>'
  }
})
